export function hideAllAction() {
  const { t } = useI18n();

  return {
    title: t('components.xeokit_viewer.context_menu.hide_all'),
    getEnabled: function (context) {
      return context.viewer.scene.numVisibleObjects > 0;
    },
    doAction: function (context) {
      console.log({ context });
      context.viewer.scene.setObjectsVisible(context.viewer.scene.visibleObjectIds, false);
    },
  };
}
